<script>
    import {PATH_PREFIX} from '../../../../apiUrls.js';
  import { fade } from 'svelte/transition';
  import { sgettext } from '../../../../i18n.js';
  import { submit } from '../../../../utils.js';
  import ConfirmationModal from '../../../ConfirmationModal.svelte';
  import AppendixRow from './AppendixRow.svelte';

  export let title;
  export let activityVersionId;
  export let urlSlug;
  export let editable = true;
  export let isWaiting = false;

  let fields = [sgettext('$$NAME$$'),  sgettext('$$APPENDIX_REFRENCE$$'), sgettext('$$DESCRIPTION$$'),  sgettext('$$FILE$$')];

  // APIs
  let listUrl = `${PATH_PREFIX}/sw/v2/api/activity_version/${activityVersionId}/${urlSlug}-readonly/`;
  let actionUrl = `${PATH_PREFIX}/sw/v2/api/activity_version/${activityVersionId}/${urlSlug}/`;

  // Retrieving saved items
  export let retrievedItems = [];
  $: items = retrievedItems;
  async function retrieveItems() {
    isWaiting = true;
    const response = await fetch(listUrl);
    isWaiting = false;

    if (response.ok) {
      const json = await response.json();
      if (json) {
        items = json.results;
      }
    }
  }

  // Creating
  let isCreating = false;
  let setCreatingMode = () => {
    //we need to get the list again when we enter creating mode to ensure we have a current list of the used alphas
    retrieveItems()
    if (editable) {
      isCreating = true;
    }
  };

  // Deleting
  let deleteConfirmationId = `activity-version-${urlSlug}-modal`;
  let isDeleting = false;
  let toDeleteItem = null;
  $: if (isDeleting && editable) {
    jQuery(`#${deleteConfirmationId}`).modal();
    jQuery(`#${deleteConfirmationId}`).on('hidden.bs.modal', function () {
      cancelDeletingMode();
    });
  }
  let cancelDeletingMode = () => {
    isDeleting = false;
    jQuery(`#${deleteConfirmationId}`).modal('hide');
  }
  async function deleteItem() {
    isWaiting = true;
    const url = `${actionUrl}${toDeleteItem.id}/`;
    const response = await submit(url, 'DELETE', {});

    if (response.ok) {
      await retrieveItems();
      cancelDeletingMode();
    }
  }

  // Expanding
  let expanded = true;
  let toggle = () => { expanded = !expanded; }
</script>

<div class="container p-0 my-4">
  <h5>
    <i
      on:click={toggle}
      class="fas mr-2"
      class:fa5-plus={!expanded}
      class:fa5-minus={expanded}
      transition:fade
    />
    {sgettext(title)} ({items.length})
  </h5>

  {#if expanded}
    <div transition:fade>
      <table class="sw table mb-2 border table-hover">
        {#if items.length != 0 || isCreating}
          <thead class="thead-light">
            <tr>
              {#each fields as field}
                <th>{field}</th>
              {/each}
              {#if editable}
                <th class="actions">{sgettext('$$ACTIONS$$')}</th>
              {/if}
            </tr>
          </thead>
        {/if}
        <tbody>
          {#each items as item}
            <AppendixRow
              {activityVersionId}
              {item}
              {fields}
              {editable}
              {retrieveItems}
              {retrievedItems}
              {actionUrl}
              bind:isDeleting
              bind:toDeleteItem
            />
          {:else}
            {#if !isCreating}
              <tr>
                <td>
                  {#if isWaiting}
                    <div class="spinner-border text-primary" role="status">
                      <span class="sr-only">{sgettext('$$LOADING$$')}...</span>
                    </div>
                  {:else}
                    {sgettext('$$NONE$$')}
                  {/if}
                </td>
              </tr>
            {/if}
          {/each}
          {#if editable && isCreating}
            <AppendixRow
              {activityVersionId}
              {fields}
              {retrieveItems}
              retrievedItems={items}
              {actionUrl}
              bind:isCreating
            />
          {/if}
        </tbody>
      </table>

      {#if !isWaiting && editable && !isCreating}
        <div class="buttons d-flex flex-nowrap justify-content-end">
          <button
            class="btn btn-outline-primary"
            role="button"
            on:click={setCreatingMode}
          >
            {sgettext('$$CREATE_NEW_1$$')}
          </button>
        </div>
      {/if}
    </div>
  {/if}
</div>

<ConfirmationModal
  id={deleteConfirmationId}
  title={sgettext('$$DELETE_CONFIRMATION$$')}
  onYes={deleteItem}
  onNo={cancelDeletingMode}
  sending={isWaiting}
>
  <div slot="message">
    <h5 class="mb-4">
      {sgettext('$$SURE_WANT_DELETE_ITEM$$')}
    </h5>
    {#if toDeleteItem}
      <p>{fields[0]}: {toDeleteItem.name}</p>
      <p>{fields[1]}: {toDeleteItem.description}</p>
      <p>{fields[2]}: {toDeleteItem.count}</p>
    {/if}
  </div>
</ConfirmationModal>

<style>
  h5 i {
    cursor: pointer;
  }

  .actions {
    text-align: right;
    min-width: 130px;
    white-space: nowrap;
  }
</style>
